import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { Dialog } from "../../../ui/Dialog/Dialog";
import { DialogHeader } from "../../../ui/Dialog/DialogHeader";
import { getPartName } from "../../../util/getPartName";
import { Footer } from "./Footer";

export const DeletePackageDialog: FunctionComponent<{
  onClose: VoidFunction;
  packageToDelete?: PackagePartItem;
  reload(): Promise<void>;
}> = ({ onClose, packageToDelete, reload }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();

  return (
    <Dialog
      className="xl:max-w-md"
      id="package-copy-dialog"
      onClose={onClose}
      placement="top"
      visible={!!packageToDelete}
    >
      <DialogHeader
        onClose={onClose}
        title={t("packageEditor.deletePackage")}
      />
      <div className="p-4">
        {t("packageEditor.packageDeleteNote", {
          packageName: getPartName(packageToDelete, language),
        })}
      </div>
      <Footer
        hide={onClose}
        packageToDelete={packageToDelete}
        reload={reload}
      />
    </Dialog>
  );
};
